import type { DashboardStatsVariant } from "@/components/non_registrant/dashboard-stats";
import { UserType } from "@/constants";

export function sectionToStatsVariant(
  section: string,
  userType: UserType,
): DashboardStatsVariant {
  if (section === "overview") return "all";
  if (section === "unregistered-properties") return "unregistered-properties";
  if (section === "inspections") return "inspections";
  if (section === "jurisdictions") return "jurisdictions";
  if (
    (section === "checks" || section === "invoices") &&
    userType === UserType.OPERATOR
  )
    return "checks";
  if (section === "reports" || section === "forecasting") return "reports";
  if (section === "registrations") return "registrations";
  if (section === "cases") return "registrations";
  if (section === "inactive-registrations") return "registrations";
  if (section === "ordinances") return "ordinances";
  return "all";
}

export function shouldShowDashboardStatsForSection(section: string): boolean {
  return (
    section !== "inactive-registrations" &&
    section !== "cases" &&
    section !== "checks" &&
    section !== "invoices" &&
    section !== "system-usage" &&
    section !== "title-requests"
  );
}

export const GOVERNMENT_SECTION_BLURBS: Record<string, string> = {
  ordinances:
    "Browse current and historic ordinance rule sets; import/export CSV from the workspace.",
  registrations: "View and manage property registrations and licenses.",
  cases:
    "ATTOM foreclosure cases indexed for your jurisdiction, linked to licenses when a Foreclosure Case Number matches.",
  "inactive-registrations": "View inactive and deregistered registrations.",
  inspections: "Schedule and track property inspections.",
  reports: "Generate and view reports on registrations and activity.",
};

export const OPERATOR_SECTION_BLURBS: Record<string, string> = {
  jurisdictions: "Manage jurisdictions and their settings.",
  "attom-tax-assessor-status":
    "Live Athena diagnostics for incremental ATTOM tax_assessor extract partitions.",
  ordinances:
    "Browse current and historic ordinance rule sets; import/export CSV from the workspace.",
  registrations: "View and manage property registrations and licenses.",
  "title-requests":
    "Review title requests with the same jurisdiction and region filters as the license list.",
  cases:
    "ATTOM foreclosure cases indexed across jurisdictions; filter by jurisdiction and link to licenses when a Foreclosure Case Number matches.",
  "inactive-registrations": "View inactive and deregistered registrations.",
  inspections: "Schedule and track property inspections.",
  refunds:
    "Allocate card/ACH refunds across properties when a payment covered multiple licenses or periods.",
  reports: "Generate and view reports on registrations and activity.",
  forecasting:
    "Projected registrations, renewals, fees, and HERA remittance for the next 12 months from unpaid existing dues and last year’s first-time timing. Growth and renewal compliance adjust the chart on this page; foreclosure survival is already applied to existing dues.",
  "system-usage":
    "Who used the system, reconstructed working time, and task mix. View only.",
};
